import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const mock = [
  {
    image:
      'https://images.pexels.com/photos/6214155/pexels-photo-6214155.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    description: 'Drive sales to your business with well crafted designs',
    title: 'E-Commerce Apps',
    color: '#183167',
  },
  {
    image:
      'https://images.pexels.com/photos/5999817/pexels-photo-5999817.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    description: 'Get your business noticed globally with beautiful layouts',
    title: 'Business Apps',
    color: '#CE371F',
  },
  {
    image:
      'https://images.pexels.com/photos/3490348/pexels-photo-3490348.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    description: 'Lets give you designs that would entice your clients',
    title: 'Fitness And Health',
    color: '#228B22',
  },
  {
    image:
      'https://images.pexels.com/photos/4968636/pexels-photo-4968636.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    description: 'You sell faster when your app is attractive',
    title: 'Marketing',
    color: '#000000',
  },
];

const Folio = () => {
  const scrollTop = () => {
    console.log('i was clicked');
    window.scrollTo({
      top: 0 + 5900,
      behavior: 'smooth',
    });
  };
  const theme = useTheme();
  return (
    <Box>
      <Grid container spacing={2}>
        {mock.map((item, i) => (
          <Grid key={i} item xs={12} md={6}>
            <Box
              sx={{
                position: 'relative',
                overflow: 'hidden',
                height: {
                  xl: '70vh',
                  lg: '70vh',
                  md: '70vh',
                  sm: '90vh',
                  xs: '90vh',
                },
                borderRadius: 2,
                '&:hover': {
                  '& img': {
                    transform: 'scale(1.2)',
                  },
                },
                '& .lazy-load-image-loaded': {
                  display: 'flex !important',
                },
              }}
            >
              <Box
                component={LazyLoadImage}
                height={1}
                width={1}
                src={item.image}
                alt="..."
                effect="blur"
                minHeight={{ xs: 400, md: 600 }}
                sx={{
                  transition: 'transform .7s ease !important',
                  transform: 'scale(1.0)',
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                }}
              />
              <Box
                position={'absolute'}
                bottom={0}
                left={0}
                right={0}
                padding={3}
                sx={{
                  backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0) 2%, ${item.color})`,
                }}
              >
                <Typography
                  variant={'h4'}
                  fontWeight={700}
                  sx={{ color: 'common.white' }}
                >
                  {item.title}
                </Typography>
                <Typography
                  variant={'h6'}
                  fontWeight={700}
                  sx={{ color: 'common.white' }}
                  gutterBottom
                >
                  {item.description}
                </Typography>
                <Button
                  size={'large'}
                  variant={'contained'}
                  color={'secondary'}
                  onClick={scrollTop}
                  sx={{
                    display: {
                      xl: 'block',
                      lg: 'block',
                      sm: 'none',
                      xs: 'none',
                    },
                  }}
                >
                  Learn more
                </Button>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Folio;
